import React, { FC, ReactChild, CSSProperties } from "react"
import { DESCRIPTION } from "../../utils/styles"
import { container, quote } from "./styles"
/** @jsx jsx */
import { css,jsx } from "@emotion/react"
interface DescriptionProps {
  type?: DESCRIPTION
  children?: ReactChild
  overrideStyle?: CSSProperties
}

/**
 * Description in the terms of use in the form of a regular description and quote
 *
 * @param {*} { children, type }
 * @returns
 */
const Description: FC<DescriptionProps> = ({
  children,
  type,
  overrideStyle,
}) => {
  switch (type) {
    case DESCRIPTION.QUOTE:
      return (
        <div style={overrideStyle} css={css`${quote} ${container}`}>
          {children}
        </div>
      )
    case DESCRIPTION.REGULAR:
    default:
      return <div css={container}>{children}</div>
  }
}

export default Description
